export const encodeJsonBase64 = (value: unknown): string => {
  const bytes = new TextEncoder().encode(JSON.stringify(value))
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('')
  return btoa(binary)
}

export const decodeJsonBase64 = (input: string): unknown => {
  const binary = atob(input.trim())
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
  return JSON.parse(new TextDecoder().decode(bytes))
}
